import { ReactElement } from 'react';

import { NotFoundPage } from '../../../../common/components/pages/NotFoundPage';
import DashboardsFeature from '../molecules/Dashboards';

export default function ArrivalPage(): ReactElement {
  return <DashboardsFeature fallback={<NotFoundPage />} />;
}
